export default Object.freeze({
  CONFIRM_DELETE: '삭제하신 상품은 판매가 불가능합니다. 정말 삭제하시겠습니까?',
  ALERT_SUCCESS: '삭제 완료',
});
